var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagFrench = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
  fill: "#C4C4C4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 0L24 24L16 24L16 -3.49691e-07L24 0Z",
  fill: "#F44653"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 0L16 24L8 24L8 -3.49691e-07L16 0Z",
  fill: "#F3F4F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 0L8 24L-1.04907e-06 24L0 -3.49691e-07L8 0Z",
  fill: "#1035BB"
}))));
export default SvgFlagFrench;